import React, { Component } from 'react'
import Icon from "../../../../common/icon/icon.component.jsx";
import { FormattedMessage } from "react-intl";
import SectionWrapper from "../../sectionwrapper.component.jsx";

class VideoContentSection extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            section: this.props.section || null,
            variables: this.props.variables || null,
            isPdf: this.props.isPdf || false,
            editable: this.props.editable || false,
            edition: this.props.edition || false,
            onEdit: this.props.onEdit || function () { },
            id: this.props.id || '',
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            section: nextProps.section || null,
            variables: nextProps.variables || null,
            id: nextProps.id || '',
            isPdf: nextProps.isPdf || false,
        })
    }

    render() {
        if (!this.state.section) {
            return <div />
        }

        let alignment = "justify-content-center"
        switch (this.state.section.attributes.content.alignment) {
            case 'center':
                alignment = "justify-content-center"
                break
            case 'left':
                alignment = "justify-content-start"
                break
            case 'right':
                alignment = "justify-content-end"
                break
        }
        const hide = this.state.editable ? '' : 'd-none'

        return (
            this.state.isPdf ? <div></div> : <SectionWrapper
                id={this.state.id}
                section={this.state.section}
                onEdit={this.state.onEdit}
                editable={this.state.editable}
                variables={this.state.variables}
            >
                <div className={'py-2 col-12 d-flex ' + alignment}>
                    {this.state.section.attributes.content.url ? <div className={"w-100 w-md-" + this.state.section.attributes.content.size + " " + "embed-responsive embed-responsive-" + this.state.section.attributes.content.ratio}>
                        <iframe className="embed-responsive-item" allow="autoplay; encrypted-media;"
                            src={this.state.section.attributes.content.url} allowFullScreen></iframe>
                    </div> :
                        <div className={hide}>
                            <p className={"section-empty-message m-0 text-left"}>
                                {this.state.section.attributes.internalName}
                            </p>
                            <p className={"section-empty-message text-left"}>
                                <Icon value={"image"} />
                                <small className={"ml-2"}>
                                    <FormattedMessage
                                        id="templates.sections.video.empty_message"
                                        defaultMessage="Video missing"
                                    />
                                </small>
                            </p>
                        </div>
                    }
                </div>
            </SectionWrapper>

        );
    }
}

export default VideoContentSection


// WEBPACK FOOTER //
// ./src/template/sections/content/video/section.component.jsx